import React from 'react';
import { Button } from 'reactstrap';
import cls from 'classnames';
import './AttendanceAssignmentFooter.scss';

class AttendanceAssignmentFooter extends React.Component {
    handleCancel = () => {
        const { onCancel } = this.props;
        onCancel();
    };

    render() {
        const {
            selectedCount,
            attendanceEventName,
            onAssign,
            isAssigning = false,
            isVisible = true,
            assignButtonLabel = 'Assign',
            assigningButtonLabel = 'Assigning...',
        } = this.props;

        return (
            <div className={cls('attendance-assignment-footer', { visible: isVisible })}>
                <div className="footer-content">
                    <div className="selection-info">
                        <span className="event-name">{attendanceEventName}</span>
                        <span className="staff-count">
                            {selectedCount}
                            {' '}
                            {selectedCount === 1 ? 'staff member' : 'staff members'}
                            {' '}
                            selected
                        </span>
                    </div>
                    <div className="action-buttons">
                        <Button
                            color="link"
                            onClick={this.handleCancel}
                            disabled={isAssigning}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            onClick={onAssign}
                            disabled={selectedCount === 0 || isAssigning}
                        >
                            {isAssigning ? assigningButtonLabel : assignButtonLabel}
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default AttendanceAssignmentFooter;
